// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "motion-kit" + "." + "7bebd221" + ".chunk.css";
};